









import ToastMessage from '@/models/ToastMessage';
import CustomerPlayroomFavoriteService from '@/services/customers/CustomerPlayroomFavoriteService';
import LoginModal from '@/components/shared/LoginModal.vue';
import Vue, { PropType } from 'vue';
import PlayroomDetailDto from '@/models/PlayroomDetailDto';

export default Vue.extend({
  components: { LoginModal },
  props: {
    playroom: {
      type: Object as PropType<PlayroomDetailDto>,
    },
  },
  data() {
    return {
      isFavorite: false,
      showLoginModal: false,
    };
  },
  mounted() {
    this.isFavorite = this.playroom.isFavorite;
  },
  computed: {
    canHaveFavorites(): boolean {
      if (!this.isLoggedIn) return true;
      var role = this.$store.state.AuthStoreModule.user.role;
      return role == 'Customer';
    },

    favIconStyle(): string {
      return this.isFavorite ? 'favorite' : 'no-favorite';
    },

    favIconName(): string {
      return this.isFavorite ? 'cis-heart' : 'cil-heart';
    },

    isLoggedIn(): boolean {
      return this.$store.state.AuthStoreModule.status.loggedIn;
    },
  },
  methods: {
    toggleFavorite() {
      if (this.isLoggedIn) {
        CustomerPlayroomFavoriteService.toggleFavorite(this.playroom.id).then((response) => {
          this.playroom.isFavorite = response.value;
          this.isFavorite = response.value;
          this.showToastMessage(this.isFavorite);
        });
      } else {
        this.openLoginModal();
      }
    },

    openLoginModal() {
      this.showLoginModal = true;
    },

    onUpdateShow() {
      this.showLoginModal = false;
    },

    showToastMessage(isFavorite: boolean) {
      let messageType = isFavorite ? 'added' : 'removed';
      const message = this.$t('components.PlayroomFavoriteIcon.' + messageType, {
        name: this.playroom.name,
      }).toString();
      this.$store.commit('addToastMessage', new ToastMessage(message, 'bg-success'));
    },
  },
});
